import React from "react";

interface ITriggerCollapseDarkIconProps {
    sizeX?: number;
    sizeY?: number;
}

export const TriggerCollapseDarkIcon: React.FC<ITriggerCollapseDarkIconProps> = ({ sizeX = 40, sizeY = 100 }) => {
    return (
        <svg width={sizeX} height={sizeY} viewBox="0 0 40 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M40 0L17.5096 6.31752C7.15518 9.22607 -1.19209e-07 18.6681 -1.19209e-07 29.4233V70.5767C-1.19209e-07 81.3319 7.15517 90.7739 17.5096 93.6825L40 100V0Z"
                fill="#523380"/>
            <path
                d="M10 46V57C10 57.5304 10.2107 58.0391 10.5858 58.4142C10.9609 58.7893 11.4696 59 12 59H26M28 55C28.5304 55 29.0391 54.7893 29.4142 54.4142C29.7893 54.0391 30 53.5304 30 53V47C30 46.4696 29.7893 45.9609 29.4142 45.5858C29.0391 45.2107 28.5304 45 28 45H24.1C23.7655 45.0033 23.4355 44.9226 23.1403 44.7654C22.8451 44.6081 22.594 44.3794 22.41 44.1L21.6 42.9C21.4179 42.6235 21.17 42.3965 20.8785 42.2394C20.587 42.0823 20.2611 42.0001 19.93 42H16C15.4696 42 14.9609 42.2107 14.5858 42.5858C14.2107 42.9609 14 43.4696 14 44V53C14 53.5304 14.2107 54.0391 14.5858 54.4142C14.9609 54.7893 15.4696 55 16 55H28Z"
                stroke="#E5DDFC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}
